// middleware/fileHelper.js
export const getPreviewFileUrl = (filePath) => {
  if (!filePath) return '';

  if (filePath.startsWith('http')) {
    return filePath;
  }

  if (filePath.startsWith('image/upload/')) {
    return `https://res.cloudinary.com/dxoecm0tx/${filePath}`;
  }

  return '';
};
